import React from 'react';
import classnames from "classnames";

const SurveyPageSkeleton = ({pathInfo = {}}) => {
  const {
    page,
    path
  } = pathInfo;

  const isAdminPage = page === "administration";
  const isGetStartedPage = page === 'get-started';
  const isWelcomePath = path === "welcome";
  const surveyPageClasses = classnames('surveyPage', 'surveyPage--skeleton', {
    'surveyPage--page-administration': isAdminPage,
    'surveyPage--path-welcome': isWelcomePath
  });
  const backgroundClasses = classnames('surveyPage--skeleton__bg', 'skeleton-bg', {
    'skeleton-bg--page-administration': isAdminPage,
    'skeleton-bg--page-get-started': isGetStartedPage,
    'skeleton-bg--path-welcome': isWelcomePath
  });

  return (
    <>
      {!isAdminPage && !isWelcomePath ? <div className="sidebar sidebar--survey"/> : null}

      {!isAdminPage && !isWelcomePath ?
        <div className={surveyPageClasses}>
          <div className="questionGroups clear">
            <section className="questionGroup questionGroup--base">
              <div className="question">
                <h4 className="question__text">
                  <span/>
                  <div className="subtext"><span/></div>
                </h4>
                <div className="question__skeleton"/>
              </div>
            </section>
          </div>
        </div> : null
      }

      {isAdminPage || isWelcomePath ? <div className={backgroundClasses} /> : null }
    </>
  )
};

export default SurveyPageSkeleton;
